module.exports = __webpack_public_path__ + "img/47_37.071e9b68.png";